<template>
  <div>
    <div v-if="isLoggedIn && isPremium">
      <b-row>
        <b-col cols="12">
          <b-card title="Market Trends">
            <b-card-text>
              <p>
                Explore the latest trends in the structured products marketplace.
                This page provides insights into market movements, popular product types,
                and emerging patterns.
              </p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12">
          <b-card title="Coming Soon">
            <b-card-text>
              <div class="text-center py-3">
                <feather-icon
                  icon="TrendingUpIcon"
                  size="48"
                  class="text-primary mb-2"
                />
                <p class="text-muted">
                  Comprehensive market trend analysis and visualizations will be available here.
                </p>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <UpgradeToPremium />
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import UpgradeToPremium from '@/views/components/UpgradeToPremium.vue'

export default {
  name: 'Trends',
  components: {
    UpgradeToPremium,
    BRow,
    BCol,
    BCard,
    BCardText,
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'isPremium',
    ]),
  },
}
</script>

<style scoped>
</style>
